import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  createChildrenSymbol,
  removeSymbolClassification,
  setScaleSegments,
  setSelectedSegment,
  Style,
} from "../../../ducks/style/style";
import {
  createClassificationSegment,
  resetClassification,
  resetClassificationHistory,
} from "../../../ducks/classification/classification";
import { castScaleToResolution } from "../../../evergis/core/scale";
import { useCurrentLayerStyle } from "./useCurrentLayerStyle";
import { getSelectedSegment } from "../../../ducks/style/selectors";

export const useCreateSegments = () => {
  const dispatch = useDispatch();
  const style = useCurrentLayerStyle();
  const selectedSegment = useSelector(getSelectedSegment);

  return useCallback(
    (segments: number[], resetStyle?: boolean) => {
      dispatch(setScaleSegments(segments));

      if (selectedSegment === undefined) {
        dispatch(setSelectedSegment(segments[0]));
      }
      if (resetStyle) {
        dispatch(removeSymbolClassification());
      }
      dispatch(resetClassification());
      dispatch(resetClassificationHistory());

      segments.slice(0, -1).forEach((segment, index) => {
        dispatch(createClassificationSegment(segment));

        if (resetStyle) {
          const [minResolution, maxResolution] = castScaleToResolution([segment, segments[index + 1]]);

          dispatch(
            createChildrenSymbol({
              ...style,
              minResolution,
              maxResolution,
              children: null,
              condition: null,
            } as Style),
          );
        }
      });
    },
    [dispatch, selectedSegment, style],
  );
};
